import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../app/providers';

export const notificationsKey = ['notifications'] as const;

/** The caller's comment notifications: on mount, on focus, every minute while the tab is visible (P7 Ruling 6). */
export function useNotifications(enabled = true) {
  const api = useApi();
  return useQuery({
    queryKey: notificationsKey,
    queryFn: () => api.myNotifications(),
    enabled: enabled && api.capabilities.comments,
    refetchOnWindowFocus: true,
    refetchInterval: () => (document.visibilityState === 'visible' ? 60_000 : false),
  });
}
